import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {

    path: '/',
    component: () => import("@/views/Auth/Login.vue")
  },
  {
    path: '/login',
    component: () => import("@/views/Auth/Login.vue")
  },
  {
    path: '/dashboard',
    component: () => import("@/views/Dashboard/Dashboard.vue")
  },
  {
    path: '/roles',
    component: () => import("@/views/IAM/Roles.vue")
  },
  {
    path: '/users',
    component: () => import("@/views/IAM/Users.vue")
  },
  {
    path: '/activities',
    component: () => import("@/views/Activities/Activities.vue")
  },
  {
    path: '/role-activities',
    component: () => import("@/views/Activities/RoleActivities.vue")
  },
  {
    path: '/work-logs',
    component: () => import("@/views/Submissions/WorkLogs.vue")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
